import React from 'react';
import { createFileRoute, isRedirect, redirect } from '@tanstack/react-router';
import { AUTHENTICATION_STORAGE_KEY } from '@/components/Auth/auth.constants';
import i18n from '@/utils/i18n/i18n';
import { toast } from 'react-toastify';

import { userManager } from '../components/Auth/UserManager';
import { Loader } from '../components/Loader/Loader';

export const Route = createFileRoute('/callback')({
  beforeLoad: async () => {
    try {
      await userManager.getUser().signinRedirectCallback();

      const storedRedirection = sessionStorage.getItem(AUTHENTICATION_STORAGE_KEY) || '/';
      sessionStorage.removeItem(AUTHENTICATION_STORAGE_KEY);

      throw redirect({ to: storedRedirection, replace: true });
    } catch (error) {
      if (isRedirect(error)) {
        throw error;
      }

      sessionStorage.removeItem(AUTHENTICATION_STORAGE_KEY);
      toast.error(i18n.t('error.message.login.failed'), {
        autoClose: 4000,
      });

      throw redirect({ to: '/', replace: true });
    }
  },
  component: () => <Loader size="large" />,
});
